import ReplayGameWaitingModal from './replay-game-waiting-modal';
export default ReplayGameWaitingModal;
